import { LocationQuery } from 'vue-router';

export function namespaceQueryParams(query: LocationQuery, namespace: string) {
  if (namespace) {
    const namespacedQuery: LocationQuery = {};
    Object.keys(query).forEach((key) => {
      namespacedQuery[`${namespace}_${key}`] = query[key];
    });
    return namespacedQuery;
  } else return query;
}
